import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: 10,
    width: '90%',
    maxWidth: 480,

    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },

  title: {
    paddingBottom: 0,
  },

  body: {
    fontFamily: 'Avenir Roman',
    color: '#323643',
    fontSize: 14,
    lineHeight: 1.5,
  },

  actions: {
    padding: '8px 24px 20px',
  },
}));

const DeferredPaymentConsentDialog = ({ open, onAgree, onCancel }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      classes={{ paper: classes.paper }}
      aria-labelledby="deferred-payment-consent-title"
      aria-describedby="deferred-payment-consent-description"
    >
      <DialogTitle id="deferred-payment-consent-title" className={classes.title}>
        How payment works
      </DialogTitle>

      <DialogContent>
        <p id="deferred-payment-consent-description" className={classes.body}>
          Your card details are securely stored with our payment processor. Nothing is charged
          today — your card is charged for each deliverable as you approve it (or it auto-approves
          after 72 hours). You can manage saved cards anytime in Settings → Payment Methods.
        </p>
      </DialogContent>

      <DialogActions className={classes.actions}>
        <Button color="primary" onClick={onCancel}>
          Cancel
        </Button>

        <Button variant="contained" color="primary" onClick={onAgree}>
          Agree &amp; Pay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeferredPaymentConsentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onAgree: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default DeferredPaymentConsentDialog;
